module.exports = __webpack_public_path__ + "img/orangetop.c9e29e4b.png";